import React from 'react';
import Typography from '@mui/material/Typography';

function VODUsage() {
    return (
        <div>
            <Typography variant="body1">VODUsage</Typography>
        </div>
    );
}

export default VODUsage;